let allProducts = [];
let filteredProducts = [];
let currentPage = 1;
let itemsPerPage = 28;
let searchTimeout = null;
let currentSort = 'relevance';
let selectedProductCategories = [];
let selectedVendors = [];
let initialCategoryId = null;
let stockFilterIn = true;
let stockFilterOut = true;
let featuredOnly = false;
let priceRange = { min: null, max: null };
let sortSelect = null;
let displayCurrencySelectSlim = null;
let lastDisplayCurrencyChoice = '';
let viewMode = (function() {
    try {
        const stored = localStorage.getItem('marketplaceViewMode');
        return (stored === 'list' || stored === 'grid') ? stored : 'grid';
    } catch (e) {
        return 'grid';
    }
})();

const MARKETPLACE_FETCH_PAGE_SIZE = 5000;

function parseMarketplaceTotal(res) {
    if (!res || res.total == null || res.total === '') {
        return null;
    }
    const n = parseInt(String(res.total), 10);
    return Number.isNaN(n) ? null : n;
}

function setMarketplaceSearchEnabled(enabled) {
    const $input = $('#productSearch');
    const $btn = $('#searchBtn');
    $input.prop('disabled', !enabled);
    $btn.prop('disabled', !enabled);
    if (enabled) {
        $input.removeAttr('title');
        $btn.removeAttr('title');
    } else {
        const msg = 'Search is available after the full catalogue has loaded.';
        $input.attr('title', msg);
        $btn.attr('title', msg);
    }
}

$(document).ready(function() {
    var searchParams = new URLSearchParams(window.location.search);
    var initialSearch = searchParams.get('search');
    if (initialSearch && typeof initialSearch === 'string') {
        $('#productSearch').val(initialSearch.trim());
    }
    var catParam = searchParams.get('category');
    if (catParam != null && catParam !== '') {
        initialCategoryId = String(catParam).trim();
    } else {
        initialCategoryId = null;
    }

    if (typeof SlimSelect !== 'undefined' && $('#sortSelect').length) {
        try {
            sortSelect = new SlimSelect({
                select: '#sortSelect',
                placeholder: 'Sort by...',
                events: {
                    afterChange: function() {
                        const val = sortSelect && sortSelect.getSelected ? sortSelect.getSelected() : null;
                        currentSort = (Array.isArray(val) ? val[0] : val) || 'relevance';
                        sortProducts();
                        renderProducts();
                        renderPagination();
                    }
                }
            });
        } catch (e) {
            console.warn('Failed to initialize SlimSelect for sortSelect:', e);
        }
    }

    if (typeof SlimSelect !== 'undefined' && $('#displayCurrencySelect').length) {
        try {
            const initialDc = typeof getMarketplaceDisplayCurrency === 'function' ? getMarketplaceDisplayCurrency() : null;
            $('#displayCurrencySelect').val(initialDc || '');
            lastDisplayCurrencyChoice = initialDc || '';
            displayCurrencySelectSlim = new SlimSelect({
                select: '#displayCurrencySelect',
                placeholder: 'Listed currency',
                events: {
                    afterChange: function() {
                        const raw = displayCurrencySelectSlim && displayCurrencySelectSlim.getSelected
                            ? displayCurrencySelectSlim.getSelected()
                            : null;
                        const val = Array.isArray(raw) ? raw[0] : raw;
                        const next = val || '';
                        if (next === lastDisplayCurrencyChoice) {
                            return;
                        }
                        lastDisplayCurrencyChoice = next;
                        if (typeof setMarketplaceDisplayCurrency === 'function') {
                            setMarketplaceDisplayCurrency(val || '');
                        }
                        reloadMarketplaceCatalog();
                    }
                }
            });
        } catch (e) {
            console.warn('Failed to initialize SlimSelect for displayCurrencySelect:', e);
        }
    }
    
    setMarketplaceSearchEnabled(false);
    loadProducts();

    $('#productsGrid').toggleClass('view-list', viewMode === 'list');
    $('.view-btn').removeClass('active');
    $(`.view-btn[data-view="${viewMode}"]`).addClass('active');

    $('#productSearch').on('input', function() {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            filterProducts();
        }, 300);
    });

    $('#productSearch').on('keypress', function(e) {
        if (e.which === 13) {
            filterProducts();
        }
    });

    $('#searchBtn').on('click', function() {
        filterProducts();
    });

    $('.product-category-filter').on('change', function() {
        if ($(this).val() === '' && $(this).is(':checked')) {
            $('.product-category-filter').not(this).prop('checked', false);
            selectedProductCategories = [];
        } else {
            $('.product-category-filter[value=""]').prop('checked', false);
            if ($(this).is(':checked')) {
                selectedProductCategories.push($(this).val());
            } else {
                selectedProductCategories = selectedProductCategories.filter(c => c !== $(this).val());
            }
        }
        filterProducts();
    });

    $(document).on('change', '.vendor-filter', function() {
        if ($(this).val() === '' && $(this).is(':checked')) {
            $('.vendor-filter').not(this).prop('checked', false);
            selectedVendors = [];
        } else {
            $('.vendor-filter[value=""]').prop('checked', false);
            if ($(this).is(':checked')) {
                selectedVendors.push($(this).val());
            } else {
                selectedVendors = selectedVendors.filter(v => v !== $(this).val());
            }
        }
        filterProducts();
    });

    $(document).on('change', '.stock-filter', function() {
        stockFilterIn = $('#stockFilterIn').is(':checked');
        stockFilterOut = $('#stockFilterOut').is(':checked');
        filterProducts();
    });

    $('#featuredFilter').on('change', function() {
        featuredOnly = $(this).is(':checked');
        filterProducts();
    });

    $('#applyPriceFilter').on('click', function() {
        priceRange.min = $('#minPrice').val() ? parseFloat($('#minPrice').val()) : null;
        priceRange.max = $('#maxPrice').val() ? parseFloat($('#maxPrice').val()) : null;
        filterProducts();
    });

    $('#mobileFiltersToggle').on('click', function() {
        $('#filtersSidebar').toggleClass('show');
    });

    $('#clearAllFilters').on('click', function() {
        $('#productSearch').val('');
        $('.product-category-filter').prop('checked', false);
        $('.product-category-filter[value=""]').prop('checked', true);
        $('.vendor-filter').prop('checked', false);
        $('.vendor-filter[value=""]').prop('checked', true);
        stockFilterIn = true;
        stockFilterOut = true;
        $('#stockFilterIn').prop('checked', true);
        $('#stockFilterOut').prop('checked', true);
        $('#featuredFilter').prop('checked', false);
        $('#minPrice').val('');
        $('#maxPrice').val('');
        selectedProductCategories = [];
        selectedVendors = [];
        featuredOnly = false;
        priceRange = { min: null, max: null };
        filterProducts();
    });

    $('#sortSelect').on('change', function() {
        if (sortSelect && sortSelect.getSelected) {
            const selected = sortSelect.getSelected();
            currentSort = Array.isArray(selected) ? selected[0] : selected;
        } else {
            currentSort = $(this).val();
        }
        sortProducts();
        renderProducts();
        renderPagination();
    });

    $('.view-btn').on('click', function() {
        const view = $(this).data('view');
        if (view === viewMode) return;
        viewMode = view;
        try {
            localStorage.setItem('marketplaceViewMode', viewMode);
        } catch (e) {}
        $('.view-btn').removeClass('active');
        $(`.view-btn[data-view="${viewMode}"]`).addClass('active');
        $('#productsGrid').toggleClass('view-list', viewMode === 'list');
    });

    $(document).on('click mousedown', '.basket-qty-input', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on('click', '.product-choose-options-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const url = $(this).attr('data-product-url');
        if (url) {
            window.location.href = url;
        }
    });

    $(document).on('click', '.add-to-basket-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        const productUid = $btn.data('product-uid');
        const productName = $btn.data('product-name');
        const price = parseFloat($btn.data('price')) || 0;
        let image = $btn.data('image') || null;
        if (image && !image.startsWith('http') && !image.startsWith('/')) {
            image = '/api/storage/view?key=' + encodeURIComponent(image);
        } else if (!image) {
            image = null;
        }
        const maxQuantity = parseInt($btn.data('max-quantity'), 10);
        const productId = $btn.data('product-id');
        const vendorOrgId = $btn.data('vendor-organisation-unit-id');
        const cartItem = {
            product_uid: productUid,
            product_id: productId != null && productId !== '' ? parseInt(productId, 10) : null,
            vendor_organisation_unit_id: vendorOrgId != null && vendorOrgId !== ''
                ? parseInt(vendorOrgId, 10)
                : null,
            product_name: productName,
            variant_id: null,
            variant_name: null,
            quantity: 1,
            price: price,
            currency: ($btn.data('currency') && String($btn.data('currency')).trim()) ? String($btn.data('currency')).trim() : 'USD',
            image: image,
            max_quantity: (maxQuantity > 0 ? maxQuantity : null)
        };
        if (typeof MarketplaceCart !== 'undefined') {
            MarketplaceCart.addItem(cartItem);
            MarketplaceCart.updateHeaderCart();
        } else {
            const cart = JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
            const key = (cartItem.product_uid || '') + '|base';
            const found = cart.find(i => (i.product_uid || '') + '|' + (i.variant_id != null ? String(i.variant_id) : 'base') === key);
            if (found) {
                found.quantity = (parseInt(found.quantity, 10) || 0) + 1;
            } else {
                cart.push(cartItem);
            }
            localStorage.setItem('marketplace_cart', JSON.stringify(cart));
            window.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        if (typeof notify !== 'undefined') {
            notify('success', 'Product added to basket');
        } else if (typeof iziToast !== 'undefined') {
            iziToast.success({ message: 'Product added to basket', position: 'topRight' });
        } else {
            alert('Product added to basket');
        }
        updateProductCardActions(productUid);
    });

    $(document).on('click', '.basket-qty-minus', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const uid = $(this).data('product-uid');
        const cartItem = getCartItemForProduct(uid);
        if (!cartItem || cartItem.quantity <= 1) return;
        const newQty = cartItem.quantity - 1;
        if (typeof MarketplaceCart !== 'undefined') {
            MarketplaceCart.updateQuantity(cartItem.index, newQty);
            MarketplaceCart.updateHeaderCart();
        } else {
            const cart = JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
            cart[cartItem.index].quantity = newQty;
            localStorage.setItem('marketplace_cart', JSON.stringify(cart));
            window.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        updateProductCardActions(uid);
    });

    $(document).on('click', '.basket-qty-plus', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const uid = $(this).data('product-uid');
        const cartItem = getCartItemForProduct(uid);
        if (!cartItem) return;
        const maxQty = (cartItem.max_quantity != null && cartItem.max_quantity > 0) ? cartItem.max_quantity : 99;
        const newQty = Math.min(maxQty, cartItem.quantity + 1);
        if (typeof MarketplaceCart !== 'undefined') {
            MarketplaceCart.updateQuantity(cartItem.index, newQty);
            MarketplaceCart.updateHeaderCart();
        } else {
            const cart = JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
            cart[cartItem.index].quantity = newQty;
            localStorage.setItem('marketplace_cart', JSON.stringify(cart));
            window.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        updateProductCardActions(uid);
    });

    $(document).on('change', '.basket-qty-input', function(e) {
        e.stopPropagation();
        const uid = $(this).data('product-uid');
        const cartItem = getCartItemForProduct(uid);
        if (!cartItem) return;
        const maxQty = (cartItem.max_quantity != null && cartItem.max_quantity > 0) ? cartItem.max_quantity : 99;
        const val = parseInt($(this).val(), 10) || 1;
        const newQty = Math.max(1, Math.min(maxQty, val));
        if (typeof MarketplaceCart !== 'undefined') {
            MarketplaceCart.updateQuantity(cartItem.index, newQty);
            MarketplaceCart.updateHeaderCart();
        } else {
            const cart = JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
            cart[cartItem.index].quantity = newQty;
            localStorage.setItem('marketplace_cart', JSON.stringify(cart));
            window.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        updateProductCardActions(uid);
    });

    $(document).on('click', '.basket-remove-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const uid = $(this).data('product-uid');
        const cartItem = getCartItemForProduct(uid);
        if (!cartItem) return;
        if (typeof MarketplaceCart !== 'undefined') {
            MarketplaceCart.removeItem(cartItem.index);
            MarketplaceCart.updateHeaderCart();
        } else {
            const cart = JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
            cart.splice(cartItem.index, 1);
            localStorage.setItem('marketplace_cart', JSON.stringify(cart));
            window.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        updateProductCardActions(uid);
    });

    $(document).on('click', '#productsPagination .page-link', function(e) {
        e.preventDefault();
        const page = $(this).data('page');
        if (page && page !== currentPage) {
            currentPage = page;
            renderProducts();
            renderPagination();
            $('html, body').animate({
                scrollTop: $('#productsGrid').offset().top - 100
            }, 300);
        }
    });
});

function reloadMarketplaceCatalog() {
    setMarketplaceSearchEnabled(false);
    $('#productsSection').addClass('d-none');
    $('#loadingState').removeClass('d-none').html(`
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted mt-3 mb-0">Loading the full catalogue…</p>
        <p class="text-muted small mt-2 mb-0">Search is available once loading finishes.</p>
    `);
    loadProducts();
}

function loadProducts() {
    const accumulated = [];
    let offset = 0;

    function showLoadError(message) {
        setMarketplaceSearchEnabled(true);
        $('#loadingState').html(`
            <div class="text-center py-5">
                <i class="fa-solid fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                <h5 class="text-muted">Error loading products</h5>
                <p class="text-muted small">${message || 'Please try again later'}</p>
            </div>
        `);
    }

    function finishLoading() {
        allProducts = accumulated;
        setMarketplaceSearchEnabled(true);
        $('#loadingState').addClass('d-none');
        $('#productsSection').removeClass('d-none');
        populateVendorFilters();
        if (initialCategoryId) {
            var $catCheckbox = $('.product-category-filter').filter(function() { return $(this).val() === initialCategoryId; });
            if ($catCheckbox.length) {
                $('.product-category-filter[value=""]').prop('checked', false);
                $('.product-category-filter').not('[value=""]').prop('checked', false);
                $catCheckbox.prop('checked', true);
                selectedProductCategories = [initialCategoryId];
            }
        }
        filterProducts();
    }

    function fetchChunk() {
        const reqData = {
            limit: MARKETPLACE_FETCH_PAGE_SIZE,
            offset: offset
        };
        const dc = typeof getMarketplaceDisplayCurrency === 'function' ? getMarketplaceDisplayCurrency() : null;
        if (dc) {
            reqData.display_currency = dc;
        }

        $.ajax({
            url: '/api/products/marketplace',
            method: 'GET',
            data: reqData,
            success: function(res) {
                if (!res.success) {
                    showLoadError(res.message);
                    return;
                }

                const batch = res.products || [];
                for (let i = 0; i < batch.length; i++) {
                    accumulated.push(batch[i]);
                }

                if (batch.length === 0) {
                    finishLoading();
                    return;
                }

                const total = parseMarketplaceTotal(res);
                const hasMore =
                    total !== null
                        ? accumulated.length < total
                        : batch.length >= MARKETPLACE_FETCH_PAGE_SIZE;

                if (hasMore) {
                    offset += batch.length;
                    fetchChunk();
                    return;
                }

                finishLoading();
            },
            error: function(xhr) {
                let errorMsg = 'Error loading products';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMsg = xhr.responseJSON.message;
                }
                showLoadError(errorMsg);
            }
        });
    }

    fetchChunk();
}

function populateVendorFilters() {
    const seen = new Set();
    const vendors = [];
    allProducts.forEach(p => {
        if (p.organisation_uid && p.organisation_name && !seen.has(p.organisation_uid)) {
            seen.add(p.organisation_uid);
            vendors.push({ uid: p.organisation_uid, name: p.organisation_name });
        }
    });
    vendors.sort((a, b) => (a.name || '').localeCompare(b.name || ''));

    const container = $('#vendorFilters');
    container.find('.filter-checkbox:not(:first)').remove();
    vendors.forEach(v => {
        container.append(`
            <div class="filter-checkbox">
                <label>
                    <input type="checkbox" class="vendor-filter" value="${escapeHtml(v.uid)}">
                    <span>${escapeHtml(v.name)}</span>
                </label>
            </div>
        `);
    });
}

function getCartItemForProduct(productUid) {
    const cart = typeof MarketplaceCart !== 'undefined' ? MarketplaceCart.getCart() : JSON.parse(localStorage.getItem('marketplace_cart') || '[]');
    const key = (productUid || '') + '|base';
    const idx = cart.findIndex(i => (i.product_uid || '') + '|' + (i.variant_id != null ? String(i.variant_id) : 'base') === key);
    if (idx < 0) return null;
    const item = cart[idx];
    return {
        index: idx,
        quantity: parseInt(item.quantity, 10) || 1,
        max_quantity: item.max_quantity != null ? parseInt(item.max_quantity, 10) : null
    };
}

function getProductActionsHtml(product, cartItem) {
    const uid = product.uid || '';
    const name = product.name || 'Product';
    const price = product.base_price || 0;
    const image = product.primary_image || '';
    const currency = (product.currency && product.currency.trim()) || 'USD';
    const inStock = product.in_stock !== false;
    if (cartItem) {
        const maxQty = (cartItem.max_quantity != null && cartItem.max_quantity > 0) ? cartItem.max_quantity : 99;
        return `
            <div class="product-basket-controls d-flex align-items-center gap-2 flex-nowrap">
                <div class="input-group input-group-sm flex-nowrap" style="max-width: 120px;">
                    <button type="button" class="btn btn-outline-secondary btn-sm basket-qty-minus py-1 px-2" data-product-uid="${escapeHtml(uid)}">−</button>
                    <input type="number" class="form-control form-control-sm text-center basket-qty-input p-1" 
                        value="${cartItem.quantity}" min="1" max="${maxQty}" data-product-uid="${escapeHtml(uid)}">
                    <button type="button" class="btn btn-outline-secondary btn-sm basket-qty-plus py-1 px-2" data-product-uid="${escapeHtml(uid)}">+</button>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm basket-remove-btn py-1 px-2 flex-shrink-0" data-product-uid="${escapeHtml(uid)}" title="Remove from basket">
                    <i class="fa-solid fa-trash"></i>
                </button>
            </div>
        `;
    }
    if (!inStock) {
        return `
            <button type="button" class="btn btn-secondary btn-sm w-100 mt-2 disabled" disabled>
                <i class="fa-solid fa-ban me-1"></i>Stock Coming Soon
            </button>
        `;
    }
    const variantRowsRaw =
        product.marketplace_variant_rows != null
            ? product.marketplace_variant_rows
            : product.variant_count;
    const variantCount = variantRowsRaw != null ? parseInt(String(variantRowsRaw), 10) : 0;
    if (variantCount > 1) {
        const productUrl = product.slug
            ? `/marketplace/product/${product.slug}`
            : `/marketplace/product/${uid}`;
        return `
            <button type="button" class="btn btn-outline-primary btn-sm w-100 mt-2 product-choose-options-btn"
                data-product-url="${escapeHtml(productUrl)}">
                <i class="fa-solid fa-sliders me-1"></i>Choose options
            </button>
        `;
    }
    const maxQty = product.total_quantity != null ? Math.max(0, parseInt(product.total_quantity, 10)) : 99;
    const pid = product.id != null ? product.id : '';
    const vid = product.organisation_unit_id != null ? product.organisation_unit_id : '';
    return `
        <button type="button" class="btn btn-primary btn-sm w-100 mt-2 add-to-basket-btn"
            data-product-uid="${escapeHtml(uid)}"
            data-product-id="${escapeHtml(String(pid))}"
            data-vendor-organisation-unit-id="${escapeHtml(String(vid))}"
            data-product-name="${escapeHtml(name)}"
            data-price="${price}"
            data-currency="${escapeHtml(currency)}"
            data-image="${escapeHtml(image)}"
            data-max-quantity="${maxQty}">
            <i class="fa-solid fa-cart-plus me-1"></i>Add to Basket
        </button>
    `;
}

function updateProductCardActions(productUid) {
    const product = filteredProducts.find(p => (p.uid || '') === productUid);
    if (!product) return;
    const cartItem = getCartItemForProduct(productUid);
    const html = getProductActionsHtml(product, cartItem);
    const $card = $(`.product-card-link[data-product-uid="${productUid}"]`);
    if ($card.length) {
        $card.find('.product-actions').html(html);
    }
}

function filterProducts() {
    const searchTerm = $('#productSearch').val().toLowerCase().trim();

    filteredProducts = allProducts.filter(product => {
        const matchesSearch = !searchTerm ||
            (product.name && product.name.toLowerCase().includes(searchTerm)) ||
            (product.description && product.description.toLowerCase().includes(searchTerm)) ||
            (product.short_description && product.short_description.toLowerCase().includes(searchTerm));

        const productCategoryId = product.product_category_id != null ? String(product.product_category_id) : '';
        const matchesCategory = selectedProductCategories.length === 0 ||
            selectedProductCategories.includes(productCategoryId);

        const matchesVendor = selectedVendors.length === 0 ||
            (product.organisation_uid && selectedVendors.includes(product.organisation_uid));

        const matchesFeatured = !featuredOnly || product.featured == 1;

        const matchesPrice = (!priceRange.min || (product.base_price && product.base_price >= priceRange.min)) &&
            (!priceRange.max || (product.base_price && product.base_price <= priceRange.max));

        const inStock = product.in_stock !== false;
        const matchesStock = (!stockFilterIn && !stockFilterOut) ||
            (stockFilterIn && inStock) ||
            (stockFilterOut && !inStock);

        return matchesSearch && matchesCategory && matchesVendor && matchesFeatured && matchesPrice && matchesStock;
    });

    sortProducts();
    updateResultsCount();
    currentPage = 1;
    renderProducts();
    renderPagination();
}

function sortProducts() {
    switch(currentSort) {
        case 'price_low':
            filteredProducts.sort((a, b) => (a.base_price || 0) - (b.base_price || 0));
            break;
        case 'price_high':
            filteredProducts.sort((a, b) => (b.base_price || 0) - (a.base_price || 0));
            break;
        case 'newest':
            filteredProducts.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
            break;
        case 'name_asc':
            filteredProducts.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            break;
        case 'name_desc':
            filteredProducts.sort((a, b) => (b.name || '').localeCompare(a.name || ''));
            break;
        default:
            break;
    }
}

function renderProducts() {
    const container = $('#productsGrid');
    container.empty();

    if (filteredProducts.length === 0) {
        container.html(`
            <div class="products-empty-state">
                <div class="text-center py-5">
                    <i class="fa-solid fa-inbox fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">No products found</h5>
                    <p class="text-muted small">Try adjusting your search or filter criteria</p>
                </div>
            </div>
        `);
        return;
    }

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const productsToShow = filteredProducts.slice(startIndex, endIndex);

    productsToShow.forEach(product => {
        const imageUrl = product.primary_image || '/assets/img/company/not_available.webp';
        const productUrl = product.slug ? `/marketplace/product/${product.slug}` : `/marketplace/product/${product.uid}`;
        const price = product.base_price ? Number(product.base_price).toFixed(2) : '0.00';
        const formattedPrice = Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const currency = (product.currency && product.currency.trim()) || 'USD';
        const dispCur = product.display_currency && String(product.display_currency).trim()
            ? String(product.display_currency).trim().toUpperCase()
            : null;
        const dispPrice = product.display_price != null && product.display_price !== ''
            ? Number(product.display_price)
            : null;
        const showApprox = dispCur && dispPrice != null && !Number.isNaN(dispPrice) && dispCur !== currency;
        const approxFormatted = showApprox
            ? dispPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '';
        
        const cartItem = getCartItemForProduct(product.uid);
        const actionsHtml = getProductActionsHtml(product, cartItem);
        const outOfStock = product.in_stock === false;
        const totalQty = product.total_quantity != null ? parseInt(product.total_quantity, 10) : 0;
        const stockText = outOfStock ? '' : (totalQty <= 5 && totalQty > 0 ? 'Only ' + totalQty + ' left' : totalQty > 0 ? totalQty + ' in stock' : '');
        const shortDesc = (product.short_description && product.short_description.trim()) ? String(product.short_description).trim() : '';
        const shortDescHtml = shortDesc ? '<div class="product-short-desc">' + escapeHtml(shortDesc.length > 100 ? shortDesc.substring(0, 97) + '...' : shortDesc) + '</div>' : '';
        const card = $(`
            <a href="${productUrl}" class="product-card-link" data-product-uid="${escapeHtml(product.uid || '')}">
                <div class="product-card">
                    <div class="product-image-container">
                        <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.name || 'Product')}" class="marketplace-product-image"
                            loading="lazy" data-fallback="/assets/img/company/not_available.webp">
                        ${outOfStock ? '<div class="product-out-of-stock-banner">Stock Coming Soon</div>' : ''}
                        ${product.featured == 1 ? '<div class="product-badge">Featured</div>' : ''}
                        <div class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="product-info">
                        <div class="product-title">
                            ${escapeHtml(product.name || 'Untitled Product')}
                        </div>
                        ${shortDescHtml}
                        <div class="product-rating">
                            <span class="text-muted small">No ratings yet</span>
                        </div>
                        <div class="product-price">
                            <span class="product-price-main">${currency} ${formattedPrice}</span>
                            ${showApprox ? `<div class="product-price-approx small text-muted mt-1">≈ ${dispCur} ${approxFormatted}</div>` : ''}
                        </div>
                        ${stockText ? '<div class="product-stock small text-success">' + escapeHtml(stockText) + '</div>' : ''}
                        <div class="product-shipping">Free shipping</div>
                        <div class="product-actions">
                            ${actionsHtml}
                        </div>
                    </div>
                </div>
            </a>
        `);
        container.append(card);
    });

    container.find('.marketplace-product-image').each(function() {
        const image = this;
        const $image = $(image);
        const $wrap = $image.closest('.product-image-container');
        const fallback = $image.data('fallback');

        const markLoaded = function() {
            $wrap.addClass('loaded');
        };

        if (image.complete && image.naturalWidth > 0) {
            markLoaded();
            return;
        }

        $image.on('load', function() {
            markLoaded();
        });

        $image.on('error', function() {
            if ($image.attr('src') !== fallback) {
                $image.attr('src', fallback);
                return;
            }
            markLoaded();
        });
    });

    updateResultsCount();
}

function renderPagination() {
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const $pagination = $('#productsPagination');
    $pagination.empty();

    if (totalPages <= 1) {
        return;
    }

    const maxVisiblePages = 7;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (currentPage > 1) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${currentPage - 1}">
                    <i class="fa-solid fa-chevron-left"></i>
                </a>
            </li>
        `);
    }

    if (startPage > 1) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="1">1</a>
            </li>
        `);
        if (startPage > 2) {
            $pagination.append(`
                <li class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
            `);
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        const isActive = i === currentPage;
        $pagination.append(`
            <li class="page-item ${isActive ? 'active' : ''}">
                <a class="page-link" href="#" data-page="${i}">${i}</a>
            </li>
        `);
    }

    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            $pagination.append(`
                <li class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
            `);
        }
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${totalPages}">${totalPages}</a>
            </li>
        `);
    }

    if (currentPage < totalPages) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${currentPage + 1}">
                    <i class="fa-solid fa-chevron-right"></i>
                </a>
            </li>
        `);
    }
}

function updateResultsCount() {
    const total = filteredProducts.length;
    const start = total === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const end = Math.min(currentPage * itemsPerPage, total);
    
    let text = '';
    if (total === 0) {
        text = 'No products found';
    } else if (total === 1) {
        text = '1 product';
    } else {
        text = `${start}-${end} of ${total} products`;
    }
    
    $('#resultsCount').text(text);
}